export enum BulkyType {
    'default' = 1,
    'mixed',
}
